import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { useNotifications } from '../hooks/useNotifications';
import { HomeIcon, HistoryIcon, BellIcon, UserIcon } from './Icons';
import './BottomNavigation.css';

const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pickups } = useApp();
  const { unreadCount } = useNotifications(pickups);

  const navItems = [
    { path: '/dashboard', icon: HomeIcon, label: 'Home' },
    { path: '/history', icon: HistoryIcon, label: 'History' },
    { path: '/alerts', icon: BellIcon, label: 'Alerts' },
    { path: '/account', icon: UserIcon, label: 'Account' }
  ];

  const isActive = (path) => {
    if (path === '/dashboard') {
      return location.pathname === '/dashboard';
    }
    if (location.pathname.includes('/pickup/')) {
      return false;
    }
    return location.pathname.startsWith(path);
  };

  // Hide on auth screens
  const hiddenPaths = ['/login', '/signup', '/forgot-password', '/verify-otp', '/reset-password', '/approval-pending', '/access-denied'];
  if (hiddenPaths.includes(location.pathname)) {
    return null;
  }

  return (
    <nav className="bottom-nav">
      <div className="bottom-nav-inner">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <button
              key={item.path}
              className={`nav-btn ${active ? 'active' : ''}`}
              onClick={() => navigate(item.path)}
              aria-label={item.label}
              aria-current={active ? 'page' : undefined}
            >
              <span className="nav-icon-box">
                <Icon size={22} color={active ? '#3b82f6' : 'currentColor'} />
                {active && <span className="nav-dot" />}
                {item.path === '/alerts' && unreadCount > 0 && (
                  <span className="nav-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
                )}
              </span>
              <span className="nav-text">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;
